module.exports = __webpack_public_path__ + "static/media/20210409_212628_276_IMG_0221.10a3c131.jpg";